import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessGradeControlsService {

  private _rights = new BehaviorSubject<ControlRights|null>(null);
  constructor() { }

  get rights(): ControlRights|null {
    return this._rights.value;
  }
  set rights(v: ControlRights) {
    this._rights.next(v);
  }

  subscribe(fn: (v: ControlRights|null) => void) {
    this._rights.subscribe(fn);
  }


}
